/* tslint:disable */
/* eslint-disable */
/**
 * Commerce Webservices
 * Manages all of the common commerce functionality, and also includes customizations from installed AddOns. The implementing extension is called commercewebservices.
 *
 * The version of the OpenAPI document: 2.2.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { SAPAppliedDiscount } from './SAPAppliedDiscount';
import {
    SAPAppliedDiscountFromJSON,
    SAPAppliedDiscountFromJSONTyped,
    SAPAppliedDiscountToJSON,
} from './SAPAppliedDiscount';
import type { SAPAppliedTax } from './SAPAppliedTax';
import {
    SAPAppliedTaxFromJSON,
    SAPAppliedTaxFromJSONTyped,
    SAPAppliedTaxToJSON,
} from './SAPAppliedTax';

/**
 * Additional cost line item on the order charged to the customer beyond the product price.
 * @export
 * @interface SAPAdditionalCostValue
 */
export interface SAPAdditionalCostValue {
    /**
     * Index of this cost item, corresponding to the position of the matching AdditionalCost in the SPI request's additionalCosts array.
     * @type {number}
     * @memberof SAPAdditionalCostValue
     */
    costNr?: number;
    /**
     * Identifier of this cost item. For delivery costs this is the delivery mode code; for payment costs this is the payment mode code. Falls back to the type code if no mode is set.
     * @type {string}
     * @memberof SAPAdditionalCostValue
     */
    code?: string;
    /**
     * Category of the additional cost, for example DELIVERY (delivery or shipping cost), PAYMENT (payment surcharge), HANDLING, or INSURANCE.
     * @type {string}
     * @memberof SAPAdditionalCostValue
     */
    type?: string;
    /**
     * Optional grouping key for this cost item.
     * @type {string}
     * @memberof SAPAdditionalCostValue
     */
    group?: string;
    /**
     * Original cost before any discounts were applied.
     * @type {number}
     * @memberof SAPAdditionalCostValue
     */
    basePrice?: number;
    /**
     * Final cost after all discounts. Equals basePrice minus the sum of all applied discount amounts.
     * @type {number}
     * @memberof SAPAdditionalCostValue
     */
    total?: number;
    /**
     * Discounts applied to this cost item by the pricing engine. Present only when discounts were applied; empty otherwise.
     * @type {Array<SAPAppliedDiscount>}
     * @memberof SAPAdditionalCostValue
     */
    appliedDiscounts?: Array<SAPAppliedDiscount>;
    /**
     * Taxes applied to this cost item.
     * @type {Array<SAPAppliedTax>}
     * @memberof SAPAdditionalCostValue
     */
    appliedTaxes?: Array<SAPAppliedTax>;
}

/**
 * Check if a given object implements the SAPAdditionalCostValue interface.
 */
export function instanceOfSAPAdditionalCostValue(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function SAPAdditionalCostValueFromJSON(json: any): SAPAdditionalCostValue {
    return SAPAdditionalCostValueFromJSONTyped(json, false);
}

export function SAPAdditionalCostValueFromJSONTyped(json: any, ignoreDiscriminator: boolean): SAPAdditionalCostValue {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'costNr': !exists(json, 'costNr') ? undefined : json['costNr'],
        'code': !exists(json, 'code') ? undefined : json['code'],
        'type': !exists(json, 'type') ? undefined : json['type'],
        'group': !exists(json, 'group') ? undefined : json['group'],
        'basePrice': !exists(json, 'basePrice') ? undefined : json['basePrice'],
        'total': !exists(json, 'total') ? undefined : json['total'],
        'appliedDiscounts': !exists(json, 'appliedDiscounts') ? undefined : ((json['appliedDiscounts'] as Array<any>).map(SAPAppliedDiscountFromJSON)),
        'appliedTaxes': !exists(json, 'appliedTaxes') ? undefined : ((json['appliedTaxes'] as Array<any>).map(SAPAppliedTaxFromJSON)),
    };
}

export function SAPAdditionalCostValueToJSON(value?: SAPAdditionalCostValue | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'costNr': value.costNr,
        'code': value.code,
        'type': value.type,
        'group': value.group,
        'basePrice': value.basePrice,
        'total': value.total,
        'appliedDiscounts': value.appliedDiscounts === undefined ? undefined : ((value.appliedDiscounts as Array<any>).map(SAPAppliedDiscountToJSON)),
        'appliedTaxes': value.appliedTaxes === undefined ? undefined : ((value.appliedTaxes as Array<any>).map(SAPAppliedTaxToJSON)),
    };
}

